import React, { useState, useEffect } from "react";
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import Select from '@mui/material/Select';
import api from "./api";
import { useOutletContext } from "react-router-dom";
import './SignInCert.css';
import oConf from './conf';
import dictionary from "./dictionary";

const { sOmsUuid } = oConf[process.env.REACT_APP_TEST ? 'oDev' : 'oProd'];
const errorHandler = er => alert(er);
const errorLog = er => console.log(er);

export function Home() {
  const [sOrderUuid, setOrderUuid] = useState();
  const [bLoading, setLoading] = useState();
  const [isLoadingPrint, setLoadingPrint] = useState();
  const [bOrderValid, setOrderValid] = useState();
  const [oReservedCodes, setReservedCodes] = useState({});
  const [aWaitStatus, setWaitStatus] = useState(JSON.parse(localStorage.waitStatusChange || "[]"));
  // const [aWaitOwner, setWaitOwner] = useState(JSON.parse(localStorage.waitOwnerChange || "[]"));
  const sOmsUrlParams = '?omsId=' + sOmsUuid + '&orderId=' + sOrderUuid;
  const [sGtin, setGtin] = useState('04670142890041');
  const [nCount, setCount] = useState(0);
  const { aAreas, setAreas } = useOutletContext();

  const fLoadCodes = () => setLoading(true) || api.getOms('/order/status' + sOmsUrlParams)
  .then(aOrderStatuses => {
    // console.log(aOrderStatuses);
    if (aOrderStatuses.find(o => o.bufferStatus == "PENDING")) {
      setTimeout(fLoadCodes, 1e3);
      return;
    }
    if (!aOrderStatuses.find(oOrder => oOrder.bufferStatus == "ACTIVE")) {
      alert('В указанном заказе нет доступных кодов (Исчерпан)');
      setLoading();
      return;
    }
    return Promise.all(aOrderStatuses.map(oOrder => oOrder.availableCodes > 0 && api.getOms(
      // '/codes'+sOmsUrlParams+'&gtin='+oOrder.gtin+'&quantity='+oOrder.availableCodes
      `/codes${sOmsUrlParams}&gtin=${oOrder.gtin}&quantity=${oOrder.availableCodes}`
    )))
    .then(aRes => aRes.reduce(
      (aCodes, oOrder) => oOrder ? aCodes.concat(oOrder.codes) : aCodes, []
    ))
    .then(aCodes => api.postDb('_bulk_docs', { docs: aCodes.map(code => {
      let [ _id, hash ] = code.split('\u001d');
      return { _id, hash }
    })}))
    .then(res => {
      if (res.filter(code => code.ok).length === res.length) {
        alert(res.length + ' код(ов) успешно загружены!');
        return;
      }
      if (res.filter(code => code.error === 'conflict').length === res.length) {
        throw new Error('Этот заказ уже был загружен.');
      }
      throw new Error(JSON.stringify(res, '', 2));
    }).finally(() => setLoading());
  }).catch(er => {
    if (er.globalErrors) {
      setLoading();
      alert(er.globalErrors[0].error);
      return;
    }
    return errorHandler(er);
  });
    
  const fOrderIdChange = ev => {
    const uOrderInput = ev.target.value;
    setOrderUuid(uOrderInput);
    setOrderValid(/^[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}$/.test(uOrderInput));
  }

  const fFlushWaites = ev => {
    delete localStorage.waitStatusChange;
    setWaitStatus([]);
  }

  const fRetired = ev => { // return console.log();
    const nOffset = sGtin == '04670142890041' ? 7 : sGtin == '04670142890027' ? 6 : 5;
    const sSkip = String(Math.random()).slice(2, nOffset);
    setLoadingPrint(true);
    api.getDb('_all_docs?include_docs=true&startkey="01' + sGtin + '"&endkey="01' + sGtin + '\ufff0"&limit=' + nCount + '&skip=' + sSkip)
    .then(oResp => oResp.rows.map(oCis => oCis.id + '\u001d' + oCis.doc.hash))
    // .then(res => console.log(res, sSkip))
    .then(aPrintCodes => fetch('http://localhost/codes/print', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json;charset=utf-8' },
        body: JSON.stringify(aPrintCodes.concat(new Date().toISOString().slice(0, 10)))
    }))
    // .then(response => response.text())
    // .then(res => {
    //     console.log(JSON.stringify(res, '', 2));
    // })
    .catch(alert)
    .finally(setLoadingPrint);
  }

  useEffect(() => {
    api.getDb('areas').then(oResp => setAreas(oResp.list));
    api.getDb('reserved').then(oResp => {
      api.post('/cises/info?pg=water', Object.values(oResp.list).reduce((all, cur) => all.concat(cur)))
      .then(aCisData => {
        const aRetires = aCisData.filter(oCis => oCis.cisInfo.status == 'RETIRED' || oCis.cisInfo.ownerInn != oCis.cisInfo.producerInn).map(oCis => oCis.cisInfo.cis);
        if (aRetires.length) {
          Object.keys(oResp.list).forEach(sArea => {
            const aNewRezervs = [];
            oResp.list[sArea].forEach(sCis => aRetires.find(sRetired => sRetired == sCis) || aNewRezervs.push(sCis));
            oResp.list[sArea] = aNewRezervs;
          })
          api.putDb('reserved', oResp)
        }
        setReservedCodes(oResp.list);
      });
    });
    aWaitStatus.length && api.post('/cises/info?pg=water', aWaitStatus.map(oItem => oItem.cis))
    .then(aInfo => {
      const aNewWaitStatuses = aWaitStatus.reduce((aNewWait, oItem, nIndex) => {
        if (oItem.status == aInfo[nIndex].cisInfo.status) aNewWait.push(oItem);
        return aNewWait;
      }, []);
      localStorage.waitStatusChange = JSON.stringify(aNewWaitStatuses);
      setWaitStatus(aNewWaitStatuses);
    });
    // aWaitOwner.length && api.post('/cises/info?pg=water', aWaitOwner.map(oItem => oItem.cis))
    // .then(aInfo => {
    //   const aNewWaitOwners = aWaitOwner.reduce((aNewWait, oItem, nIndex) => {
    //     const oInfo = aInfo[nIndex].cisInfo;
    //     if (oInfo.status == 'INTRODUCED' && oInfo.ownerInn == oItem.owner) aNewWait.push(oItem);
    //     return aNewWait;
    //   }, []);
    //   localStorage.waitOwnerChange = JSON.stringify(aNewWaitOwners);
    //   setWaitOwner(aNewWaitOwners);
    // });
  }, []);

  return <Box sx={{ m: 3 }}>
    <TextField
      label="Идентификатор заказа"
      size="small"
      value={sOrderUuid}
      onChange={fOrderIdChange}
      sx={{ width: 400, mr: 1 }}
      error={sOrderUuid && !bOrderValid}
      helperText={sOrderUuid && !bOrderValid && 'Введённая строка не соответствует формату UUID'}
    />
    <Button
      variant="contained"
      onClick={fLoadCodes}
      className={bLoading ? 'crpt-submit crpt-load' : 'crpt-submit'}
      disabled={bLoading || !bOrderValid}
      sx={{ width: 200 }}
    >
      {bLoading ? '' : 'Загрузить коды'}
    </Button>
    <Typography sx={{ py: 2 }}>
      Зарезервированные коды:
    </Typography>
    <Stack>
      {Object.entries(oReservedCodes).map(([sAreaName, aCodes]) => <Typography sx={{ p: 2 }}
        key={sAreaName}
      >
        {aAreas.length && aAreas[sAreaName.slice(4)].name + ': ' + aCodes.length}
        {sAreaName == 'area3' && <Button
          variant="contained"
          sx={{ mx: 2 }}
          onClick={ev => {
            aCodes = aCodes.map(id => '"' + id.replace(/"/g, '""') + '"');
            const link = document.createElement('a');
            const blob = new Blob(['1,Вода питьевая обработанная негазированная (19 л.),,,,,КИЗ,' + aCodes.join(',')], { type: 'text/plain' });
            link.download = 'Коды для УПД (' + aCodes.length + ' шт.).csv';
            link.href = URL.createObjectURL(blob);
            link.click();
            URL.revokeObjectURL(link.href);
          }}
        >
          Коды для УПД
        </Button>}
      </Typography>)}
    </Stack>
    <Typography sx={{ pt: 3 }}>
      Ожидают изменения статуса: {aWaitStatus.length || 0}
      <Button
        variant="contained"
        onClick={fFlushWaites}
        className='crpt-submit'
        disabled={!aWaitStatus.length}
        sx={{ mx: 2 }}
      >
        Удалить (при ошибке)
      </Button>
    </Typography>
    {/* <Typography sx={{ pt: 3 }}>
      Ожидают изменения владельца: {aWaitOwner.length || 0}
    </Typography> */}
    <Box sx={{ pt: 3 }}>
      <span style={{ fontSize: 'large' }}>Выведенные коды</span>
      <Select
        sx={{ ml: 2, width: 100 }}
        size="small"
        label="Age"
        value={sGtin}
        onChange={ev => setGtin(ev.target.value)}
      >
        {Object.entries(dictionary.gtin).map(([sKey, sVal]) => <MenuItem key={sKey} value={sKey}>{sVal.slice(17)}</MenuItem>)}
      </Select>
      <TextField
        label="Количество"
        type="number"
        name='codesCount'
        value={nCount}
        inputProps={{ min: 1, max: 440000 }}
        onChange={ev => setCount(ev.target.value)}
        onClick={ev => ev.target.select()}
        sx={{ mx: 2, width: 100 }}
        size="small"
      />
      <Button
        variant="contained"
        onClick={fRetired}
        className={isLoadingPrint ? 'crpt-submit crpt-load' : 'crpt-submit'}
        disabled={isLoadingPrint}
        sx={{ width: 100 }}
      >
        {isLoadingPrint ? '' : 'Печать'}
      </Button>
    </Box>
  </Box>
}
